<script>
	// Stores 
	import { alt } from '../store.js';  

	// Componentes
	import { link }		from "svelte-routing";
	import PageHeader	from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Serviços para Proprietários';

	let items = [
		{
			icon: 'fal fa-user-lock',
			message: 'Área do cliente com acesso ao demonstrativo de proprietário, contratos ativos, entre outros.'
		},
		{
			icon: 'fal fa-camera-retro',
			message: 'Fotos profissionais, vídeo e tour virtual.'
		},
		{
			icon: 'fal fa-user-headset',
			message: 'Atendimento humanizado, com agilidade no retorno e centralizado em um colaborador, evitando que o seu problema passe por diversos setores sem ser resolvido.'
		},
		{
			icon: 'fal fa-file-check',
			message: 'Exigimos as melhores garantias de aluguel, com criteriosa análise da documentação.'
		},
		{
			icon: 'fal fa-chart-bar',
			message: 'Avaliação personalizada do valor de aluguel, estabelecendo custo de acordo com o mercado imobiliário.'
		},
		{
			icon: 'fal fa-user-check',
			message: 'Nossos especialistas fazem uma análise de crédito rigorosa através das melhores ferramentas do mercado, garantindo que sejam aprovados somente os melhores inquilinos.'
		},
		{
			icon: 'fal fa-handshake-alt',
			message: 'Taxa de intermediação com possibilidade de parcelamento em até 4x.'
		},
		{
			icon: 'fal fa-balance-scale',
			message: 'Assistência jurídica sem custos, para cobrança de aluguéis em atraso e consultas.'
		},
		{
			icon: 'fal fa-money-check-alt',
			message: 'Pagamento dos encargos/impostos sob a responsabilidade da Bona enquanto o mesmo estiver alugado, tal medida lhe resguarda assegurando que todos os encargos incidentes sobre o imóvel estão sendo solvidos em dia.'
		},
		{
			icon: 'fal fa-megaphone',
			message: 'Divulgamos os imóveis a serem alugados no site da Bona e nos portais digitais, além de placas e cartazes no local.'
		},
		{
			icon: 'fal fa-hand-holding-usd',
			message: 'Garantimos aluguel em caso de inadimplência.'
		},
		{
			icon: 'fal fa-badge-percent',
			message: 'Taxa de administração diferenciada.'
		},
		{
			icon: 'fal fa-file-signature',
			message: 'Elaboração do contrato de locação e administração 100% on-line a fim de agilizar o processo, dentro das melhores cláusulas e condições que a lei permite, com criteriosa análise cadastral dos envolvidos, buscando uma locaçãosegura e rentável.'
		},
		{
			icon: 'fal fa-clipboard-check',
			message: 'A vistoria do imóvel é registrada através de fotos detalhadas de cada item e/ou peças, não deixando possibilidade no momento da desocupação do locatário e fiadores se isentarem de entregá-lo da mesma forma que foi recebido.'
		},
	];
</script>

<PageHeader title={titlePage}>
	<div class="subtitle" slot="subtitle">
		<div class="container">
			<p>Conheça nossos diferenciais e como a Bona pode ajudar na administração da locação do seu imóvel.</p>
		</div>
	</div>
</PageHeader>

<div class="container">
	<div class="offset-md-3 col-md-6 pl-0 pr-0 pb-40">
		<iframe title="Vídeo institucional" style="width: 100%" height="450" src="https://www.youtube.com/embed/aUEyBP2N5Ec?rel=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
	</div>
	<div class="box-itens-icon">
		{#each items as item}
		<div class="item">
			<div class="icone">
				<i class="{item.icon} fa-3x fa-fw color-accent"></i>
			</div>
			<div class="info">
				<p>{item.message}</p>
			</div>
		</div>
		{/each}
	</div>
	<p class="pt-20">Aproveite todas estas vantagens e <b>Anuncie seu imóvel</b> hoje mesmo.</p>
	<div class="button text-center mt-40">
		<a href="/anuncie" class="btn btn-primary">Anuncie seu imóvel <i class="far fa-arrow-right"></i></a>
	</div>

</div>